import React, { useState } from "react";
import axios from "axios";
import "./Login.css";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email.trim()) return alert("Please enter your email.");
    if (!password.trim()) return alert("Please enter your password.");

    setLoading(true);

    try {
      const payload = { email, password };
      const response = await axios.post("https://sattawalaonline.com/api/login", payload);

      console.log("Full login API response:", response.data);

      // ✅ Handle all possible success keys
      const isSuccess =
        response.data.token ||
        response.data.success === true ||
        response.data.status === true ||
        response.data.message?.toLowerCase().includes("success");

      if (isSuccess) {
        if (response.data.token) localStorage.setItem("token", response.data.token);
        alert("Login successful!");
        navigate("/admin-dashboard");
      } else {
        alert(response.data.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login error:", err);
      alert("Login failed. Please check your credentials or try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sattaLogin-container">
      <div className="sattaLogin-box">
        <h2 className="sattaLogin-title">Welcome to SattaWala</h2>
        <p className="sattaLogin-subtitle">Login to your account</p>

        <form className="sattaLogin-form" onSubmit={handleLogin}>
          <label>Email</label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email"
            autoComplete="off"
          />

          <label>Password</label>
          <div className="sattaLogin-password">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
            <span
              className="sattaLogin-showHide"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </span>
          </div>
          <div className="sattalogin-button">
          <button type="submit" className="sattaLogin-btn" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
